export const isValidUrl = (value: string, allowHttp = false) => {
	try {
		const url = new URL(value);
		return url.protocol === 'https:' || (allowHttp && url.protocol === 'http:');
	} catch {
		return false;
	}
};
